import React, { useCallback } from 'react'
import cn from 'classnames'

import styles from './ToggleButtonGroup.module.scss'

type ToggleButton<TValue> = {
  value: TValue
  name: string
}

type ToggleButtonGroupProps<TValue> = {
  className?: string
  list: ToggleButton<TValue>[]
  value: TValue
  onChange: (value: TValue) => void
}
export const ToggleButtonGroup = <TValue,>({
  className,
  list,
  value,
  onChange,
}: ToggleButtonGroupProps<TValue>) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.list}>
        {list.map((item) => (
          <Item
            key={String(item.value)}
            isActive={item.value === value}
            name={item.name}
            value={item.value}
            onClick={onChange}
          />
        ))}
      </div>
    </div>
  )
}

type ItemProps<TValue> = {
  onClick: (value: TValue) => void
  value: TValue
  name: string
  isActive: boolean
}
const Item = <TValue,>({
  onClick,
  name,
  isActive,
  value,
}: ItemProps<TValue>) => {
  const click = useCallback(() => {
    onClick(value)
  }, [value, onClick])
  return (
    <button
      onClick={click}
      className={cn(styles.button, {
        [styles.isActive]: isActive,
      })}
    >
      {name}
    </button>
  )
}
